<template>
    <template-block
        v-if="localModel"
        type="Knapp"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <input-with-validation
                label="Knapptext"
                :vid="vid + '.text'"
                v-model="localModel.text"
                @input="emitChange"
                placeholder="Klicka här"
            ></input-with-validation>
            <input-with-validation
                label="Länk"
                :vid="vid + '.href'"
                v-model="localModel.href"
                @input="emitChange"
                placeholder="https://example.com/##SomeVariable##"
            ></input-with-validation>
            <input-with-validation
                label="Max bredd"
                :vid="vid + '.width'"
                v-model="localModel.width"
                @input="emitChange"
                placeholder="Bredd"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft över+under"
                :vid="vid + '.paddingY'"
                v-model="localModel.paddingY"
                @input="emitChange"
                placeholder="Luft över+under"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft vänster+höger"
                :vid="vid + '.paddingX'"
                v-model="localModel.paddingX"
                @input="emitChange"
                placeholder="Luft vänster+höger"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Hörnradie"
                :vid="vid + '.borderRadius'"
                v-model="localModel.borderRadius"
                @input="emitChange"
                placeholder="Hörnradie"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <select-with-validation
                v-model="localModel.fontFamily"
                :vid="vid + '.fontFamily'"
                label="Font"
                :reduce="(opt) => opt.id"
                component="ecard-template-fonts-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.fontSize"
                :vid="vid + '.fontSize'"
                label="Textstorlek"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.align"
                :vid="vid + '.align'"
                label="Knapp-placering"
                :reduce="(opt) => opt.id"
                :options="[
                    { label: 'Vänster', id: 'left' },
                    { label: 'Centrerad', id: 'center' },
                    { label: 'Höger', id: 'right' },
                ]"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <color-picker
                :vid="vid + '.color'"
                label="Textfärg"
                v-model="localModel.color"
                @input="emitChange"
            ></color-picker>
            <color-picker
                :vid="vid + '.buttonColor'"
                label="Knapppfärg"
                v-model="localModel.buttonColor"
                @input="emitChange"
            ></color-picker>
        </div>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import ColorPicker from '@components/Form/ColorPicker.vue';

export default {
    name: 'BlockButton',
    components: {
        ColorPicker,
        SelectWithValidation,
        InputWithValidation,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
        fontSize(newVal) {
            this.localModel.lineHeight = newVal + 4;
            this.emitChange();
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'button',
                id: newVal.id || genUUID(),
                text: newVal.text || '',
                align: newVal.align || 'center',
                buttonColor: newVal.buttonColor || '#4FAF4B',
                paddingY: newVal.paddingY ?? 10,
                paddingX: newVal.paddingX ?? 25,
                color: newVal.color || '#FFFFFF',
                fontSize: newVal.fontSize ?? 14,
                fontFamily: newVal.fontFamily || 'inherit',
                borderRadius: newVal.borderRadius ?? 3,
                href: newVal.href || '',
                width: newVal.width ?? 200,
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
            this.useMediabank = newVal.mediaId > 0;
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
